module.exports = {
  language: {
    name: 'En'
  },
  header: {
    title: '服务协议'
  },
  privacyAgreement: {
    title: 'BIBF云书展个人信息隐私政策协议',
    contents: [
      {
        contentArr: [
          '更新日期：2021年09月08日',
          '生效日期：2021年09月08日'
        ]
      },
      { content: '【中国图书进出口（集团）有限公司】运营的BIBF云书展（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。' },
      { content: '鉴于网络的特性，BIBF云书展将无可避免地与您产生直接或间接的互动关系，为切实保护本平台用户的隐私权，优化用户体验，BIBF云书展根据现行法规及政策，制定此《个人信息隐私政策协议》。' },
      { content: '本《个人信息隐私政策协议》将详细说明BIBF云书展平台对用户个人信息所采取的收集、使用和保护政策，本《个人信息保护政策》适用于BIBF云书展各平台向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的服务。' },
      { content: '请您务必仔细阅读，如您对本《个人信息隐私政策协议》有任何疑问，您可以通过客服与我们联系，客服邮箱：sales@bibf.net。我们会及时解决您的问题。本《个人信息保护政策》包括了以下几个方面的问题：' },
      {
        contentArr: [
          '1. 本平台如何收集和使用您的个人信息',
          '2. 本平台如何使用Cookies',
          '3. 本平台信息的合理共享、转让及披露原则',
          '4. 本平台将如何保护信息安全',
          '5. 您在本平台的个人信息管理权利',
          '6. 信息的查询、更正和补充',
          '7. 未成年人个人信息的保护',
          '8. 《个人信息保护政策》的更新和修改',
          '9.  法律适用及争议解决'
        ]
      },
      { content: '一、本平台如何收集和使用您的个人信息' },
      {
        contentArr: [
          '在您使用BIBF云书展前，我们会引导您阅读本协议，并在您接受本协议的基础上，获得您的相关个人信息。如果您不同意提供个人信息，您将无法使用BIBF云书展的全部或部分功能和服务，或无法获得更个性化的功能，或无法参加某些活动，或无法收到我们的通知等。',
          '我们会出于本政策所述的以下场景和目的，收集和使用您的个人信息：',
          '（一）登录和注册',
          '如果您成为我们的注册用户，我们会收集您的账户昵称、密码、手机号码、邮箱等信息。我们可通过如上信息向您推广、介绍产品、发送业务通知或与您进行业务沟通。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的用户及提供上述信息。',
          '在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。',
          '（二）身份认证',
          '在您使用评论、投稿等功能时，BIBF云书展会对您进行手机号验证，如果您拒绝提供有关信息，BIBF云书展根据《互联网跟帖评论服务管理规定》可能不会向您提供相关服务。',
          '（三）个性化服务与活动',
          '为改善我们的产品或服务、向您提供个性化的信息搜索及交易服务，我们会根据您的行为习惯并基于特征标签，来进行间接人群画像展示、推送更符合您喜好的信息。',
          '在您使用BIBF云书展提供的位置定位服务时，我们会收集您的位置信息、设备信息等，以便于给您提供您所在城市的有关资讯，使新闻内容更加贴近生活和有趣。BIBF云书展保证在您的设备使用定位服务时不会收集其他无关信息。',
          '在您使用BIBF云书展提供的搜索服务时，我们会收集您的查询关键字信息、设备信息等，为了提供高效的搜索服务，这些信息有部分会暂时存储在您的本地存储设备之中。此处您的关键词信息无法单独识别您的个人身份，其不属于您的个人信息，因此我们有权以其他的目的对其进行使用，只有当您的搜索关键词信息与您的其他信息互有联系并可以识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本个人信息保护政策对其进行处理与保护。',
          '当您参加BIBF云书展举办的有关营销活动时，我们会收集您的姓名、身份证号、联系方式等信息。这些信息是您的购票信息，如果您拒绝提供这些信息，我们将无法向您售票。',
          '当使用IM场景功能时，我们会获取您的以下权限：相机权限，以便用于拍摄您所需要的图片；麦克风权限，以便于拍摄您所需要的视频；添加照片权限，以便于为您保存喜欢的图片；相册访问权限，以便于使用相关图片',
          '基于对您信息的有效保护并且在您同意的基础上，我们会对收集到的您的信息进行加密处理，以保护您的信息安全。在此希望您了解并接受在不透露您个人信息的前提下，BIBF云书展有权对您的行为信息和基本特征信息进行分析，并用于BIBF云书展功能和体验服务的优化。',
          '为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性、识别账号异常状态，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：',
          '设备信息：',
          '为了为您提供验证码识别账号异常状态服务，我们会在App内集成顶象SDK，顶象SDK会接收并记录您所使用的设备相关信息（包括设备型号、操作系统、设备设置、唯一设备标识符（IMEI码）、网络设备硬件地址（MAC）、设备序列号、设备环境等软硬件特征信息，设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等信息）',
          '日志信息：',
          '当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。',
          '位置信息：',
          '当您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息。您可以通过关闭定位功能，停止对您的地理位置信息的收集。',
          '请注意，单独的设备信息、日志信息、位置信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。',
          '（五）征得授权同意的例外',
          '根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：',
          '1、与国家安全、国防安全有关的；',
          '2、与公共安全、公共卫生、重大公共利益有关的；',
          '3、与犯罪侦查、起诉、审判和判决执行等有关的；',
          '4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
          '5、所收集的个人信息是您自行向社会公众公开的；',
          '6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；',
          '7、根据您的要求签订合同所必需的；',
          '8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；',
          '9、为合法的新闻报道所必需的；',
          '10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
          '11、法律法规规定的其他情形。',
          '注：本个人信息保护政策涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证、相关身份证明等）；个人位置信息；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、密保）；通讯录；个人上网记录（包括搜索记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、操作系统类型、获取设备序列号、软件列表唯一设备识别码（如android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；',
          '为了统计分析的目的，我们的产品可能会集成第三方的SDK或其他类似的应用程序，例如【友盟+】SDK，【友盟+】SDK需要收集您设备的广告标识符（如IMEI、MAC、IDFA等)等信息。为了您的信息安全，我们已与第三方SDK服务商签署严格数据安全保密协议，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的个人身份信息。为便于您更好地了解友盟采集的数据类型及用途，以及何保护您的个人信息，您可以登陆https://www.umeng.com/policy 了解【友盟+】隐私权政策。',
          '分享服务供应商：我们的产品通过友盟+SDK作为管理器，集成了微博、微信、qq、钉钉等分享平台SDK,分享过程中需要采集设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)，用于唯一标识设备，以便向目标设备分享消息。采集地理位置甄别分享通道，提供反作弊服务。',
          '个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本个人信息保护政策中涉及的个人敏感信息包括：个人身份信息；网络身份识别信息（包括账户名、账户昵称、邮箱地址及与前述有关的密码）；其他信息（包括通讯录、个人电话号码、手机号码、网页浏览记录、精准定位信息、收款账户）；相关身份证明',
          '另，如在上述场景之外获得您的个人信息，将重新征得您的明示同意，并在获得您明示同意前向您充分说明应用场景与获取您相关信息的内容与范围。'
        ]
      },
      { content: '二、本平台如何使用Cookies' },
      {
        contentArr: [
          '（一）Cookie',
          '为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或浏览习惯。',
          '您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。',
          '（二）网站信标和像素标签',
          '除Cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。',
          'BIBF云书展承诺，对Cookie信息的研究仅用于提升服务/产品质量及优化用户体验之目的。'
        ]
      },
      { content: '三、本平台信息的合理共享、转让及披露原则' },
      {
        contentArr: [
          '（一）共享',
          '我们不会与BIBF云书展服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：',
          '1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。',
          '2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。',
          '（二）转让',
          '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
          '1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；',
          '2、在BIBF云书展服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。',
          '（三）公开披露',
          '我们仅会在以下情况下，公开披露您的个人信息：',
          '1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；',
          '2、如果我们确定您出现违反法律法规或严重违反BIBF云书展相关协议规则的情况，或为保护BIBF云书展及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或BIBF云书展相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及BIBF云书展已对您采取的措施。',
          '3、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。',
          '（四）共享、转让、公开披露个人信息时事先征得授权同意的例外',
          '以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：',
          '1、与国家安全、国防安全有关的；',
          '2、与公共安全、公共卫生、重大公共利益有关的；',
          '3、与犯罪侦查、起诉、审判和判决执行等有关的；',
          '4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
          '5、您自行向社会公众公开的个人信息；',
          '6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。',
          '根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。'
        ]
      },
      { content: '四、本平台将如何保护信息安全' },
      {
        contentArr: [
          '（一）本平台信息保护措施',
          '本平台将对您的个人信息做符合行业标准的加密存储、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用；同时采取同样加密方式的异地备份，防止您的个人信息丢失、损坏或遭篡改。本平台将采取周期性的扫描、定期的渗透测试服务等技术措施保障服务的安全可靠。',
          'BIBF云书展通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。我们会部署访问控制机制，仅允许有必要知晓这些信息的BIBF云书展员工访问个人信息，并要求他们履行相应的保密义务。以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。',
          '我们只会在达成本政策所述目的所需的期限内或法律要求的期限内保留您的个人信息，除非延长保留期征得您的同意或受到法律的允许。本平台会严格按照国家法律法规对您的个人信息进行管理及保护。',
          '（二）个人对信息保护的义务',
          '请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络BIBF云书展客服，以便我们根据您的申请采取相应措施。',
          '请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发表评论时或发布文章时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。',
          '请使用复杂密码，协助我们保证您的账号安全。BIBF云书展通过给全量用户发送通知来提醒更改密码。还可能通过电话、短信等各种方式触达用户知晓，制止数据泄露。',
          'BIBF云书展提供的个人信息保护措施仅适用于BIBF云书展平台，一旦您离开BIBF云书展，浏览或使用其他网站、服务及内容资源，BIBF云书展即没有能力及义务保护您在BIBF云书展以外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于BIBF云书展的链接或引导。',
          '（三）个人信息安全事件应对措施',
          '我们将尽力保障您发送给我们的任何信息的安全性，但请您理解，可能存在黑客政击、计算机病毒侵入或发作、政府管制等影响信息安全的不可抗力因素。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。',
          '在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。',
          '同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。'
        ]
      },
      { content: '五、您在本平台的个人信息管理权利' },
      {
        contentArr: [
          '我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。您有权利查询、更正、管理、删除自己的信息并保护自己的隐私和安全。',
          '(一) 访问您的个人信息',
          '除法律法规规定的例外情况，无论您何时使用我们的服务，我们都会力求让您顺利访问自己的个人信息。您可以随时行使您的访问权利，如果您希望访问或编辑您的帐户中的个人资料信息、更改您的密码、添加安全信息等，您可以在您使用的产品中执行此类操作。',
          '(二) 更正或补充您的个人信息',
          '当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您有权作出更正或更新。您可以自行在我们系统内进行更正，或通过反馈与报错等将您的更正申请提交给我们。在您进行更新或更正前，我们可能会先要求您验证自己的身份，然后再处理您的请求。',
          '(三) 删除您的个人信息',
          '1.您可以通过产品中的设置或功能控件删除您的信息。',
          '2.发生以下情形，您可以向我们提出删除个人信息的请求：',
          '（1）如果我们处理个人信息的行为违反法律法规；',
          '（2）如果收集、使用您的个人信息，却未征得您的同意；',
          '（3）如果我们处理个人信息的行为违反了与您的约定；',
          '（4）如果我们终止产品运营及服务。',
          '若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。',
          '当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。',
          '(四) 改变您授权同意的范围',
          '1. 您可以通过解除绑定、修改个人设置、注销账户等方式撤回部分授权，也可以通过关闭功能的方式撤销授权。',
          '2. 当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。',
          '(五) 响应您的账户信息处理请求',
          '如果您对本个人信息保护政策或其中有关您个人信息的收集、使用、存储、保护等功能存在意见或建议时，您可以通过BIBF云书展客户服务渠道反馈意见或投诉，为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将尽快给您答复，如您不满意，还可以BIBF云书展客服发起投诉。',
          '对于那些无端重复、需要过多技术手段 （例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。',
          '在以下情形中，按照法律法规要求，我们将无法响应您的请求：',
          '1、与国家安全、国防安全有关的；',
          '2、与公共安全、公共卫生、重大公共利益有关的；',
          '3、与犯罪侦查、起诉、审判和执行判决等有关的；',
          '4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；',
          '5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；',
          '6、涉及商业秘密的。',
          '(六) 关闭功能和注销账户',
          '您可以通过关闭BIBF云书展部分功能的方式阻止BIBF云书展获得您的个人信息，关闭部分功能之后，我们将无法向您提供相应的服务。',
          '您可以联系BIBF云书展客服，注销BIBF云书展账号以保障BIBF云书展不再收集您的个人信息。在您申请注销您的账号之前，您需要确认与界面账号相关的所有服务均已进行妥善处理。',
          '您注销账号的行为是不可逆的行为，在完成注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理，保证这些信息不会泄露，同时，您也无法通过已注销的账户获得BIBF云书展的服务。',
          '如果BIBF云书展终止服务或运营，我们会提前（通过邮件、系统通知等方式）向您发出通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。'
        ]
      },
      { content: '六、未成年人个人信息的保护' },
      {
        contentArr: [
          'BIBF云书展非常重视对未成年人个人信息的保护。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人，建议您请您的父母或监护人仔细阅读本隐私权政策。14周岁以下的未成年人，在使用BIBF云书展的服务前，在确保事先取得监护人的同意后，方可使用BIBF云书展服务；已满14不满18岁的未成年人，在确保事先取得本人或监护人的同意后，才能使用BIBF云书展服务。',
          '申请账号后，默认您已经同意以上条款，BIBF云书展将根据国家相关法律法规及本《个人信息保护政策》的规定保证未成年人的个人信息的保密性和安全性。'
        ]
      },
      { content: '七、《个人信息隐私政策协议》的更新和修改' },
      {
        contentArr: [
          '为了给您提供更好的服务，以及随着我们业务的发展，个人信息保护政策也会随之更新。本平台之《个人信息隐私政策协议》的修改及更新权均属于界面(上海)网络科技有限公司。',
          '如本《个人信息隐私政策协议》发生变更，本平台将以推送通知、发送电子邮件或在BIBF云书展网站发布公告的方式来通知您，以便您能及时了解最近更新的内容。变更后的《个人信息隐私政策协议》将从通知或网站规定的生效日期开始适用。若您在本政策修订后继续使用本平台的服务，即表示您已充分阅读、理解并接受了修订后的政策并愿意受修订后的政策的约束。',
          '未经您明确同意，BIBF云书展不会削减您依据当前生效《个人信息隐私政策协议》所应享有的权利。'
        ]
      },
      { content: '八、法律适用及争议解决' },
      {
        contentArr: [
          '1.本《个人信息隐私政策协议》的成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区法律。',
          '2.如果您对本《个人信息隐私政策协议》有任何疑问，请您联系BIBF云书展客服咨询，我们会及时解决您的问题。',
          '3.因本《个人信息隐私政策协议》解释或执行引起任何争议和纠纷时，双方应首先协商友好解决；您和本平台均同意如协商不成时，则任一方均可将争议提交北京仲裁委员会依据其届时有效的仲裁规则以仲裁方式解决。仲裁裁决为终局的，对各方均有法律约束力。'
        ]
      }
      // { content: '<div style="font-weight: bold; text-indent: 2em;">如对本《隐私政策》或相关事宜有任何问题，请通过本网站与我们联系。</div>', id: '12' }
    ]
  },
  serviceAgreement: {
    title: '服务条款',
    contents: [
      { content: '中国图书进出口（集团）有限公司是本“BIBF云书展”的提供商及技术管理者，BIBF是指Beijing International Book Fair（中文名：北京国际图书博览会，简称：图博会） 请认真阅读以下适用于参展商或个人的服务条款：', id: '1' },
      { content: '1、”BIBF云书展”服务条款', id: '2' },
      { content: '“BIBF云书展”提供的服务将完全按照服务条款严格执行。用户必须完全同意所有服务条款，才能成为” BIBF云书展”的正式用户。特别提醒：若不接受本条款，请不要使用” BIBF云书展”提供的服务。当您使用” BIBF云书展”提供的服务时，即表明已详细阅读及了解本条款，明确知晓并同意了本条款中关于” BIBF云书展”的免责内容，并同意受本条款约束。” BIBF云书展”可能随时以更新网页方式单方面修改本条款，而不会作另行通知。您应定期浏览此网页【网址为：www.bibf.net 】，以了解对您具有约束力的条款是否有所修改。', id: '3' },
      {
        contentArr: [
          '考虑到” BIBF云书展”所提供的网络服务的重要性及用户的特殊性，用户应同意：',
          '（1）注册时提供详尽、准确、真实的公司或个人资料。如公司或个人资料有任何变动，必须及时更新。如果用户提供的资料不准确，不真实，不合法有效，” BIBF云书展”保留停止用户使用各项服务的权利。',
          '（2）推荐版权图书应为合法出版物，且版权真实有效'
        ],
        id: '4'
      },
      { content: '2、用户的帐号，密码和安全性', id: '5' },
      { content: '用户一旦注册成功，成为” BIBF云书展”的合法用户，将得到一个密码和用户名。如果您未保管好自己的帐号和密码而对您、” BIBF云书展”或第三方造成的损害，您将负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。您可随时改变您的密码，用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告” BIBF云书展”', id: '6' },
      { content: '3.拒绝担保', id: '7' },
      { content: '用户个人对网络服务的使用承担风险，” BIBF云书展”对此不作任何类型的担保，无论是明示的或默示的。” BIBF云书展”不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。” BIBF云书展”不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生都不作担保。', id: '8' },
      { content: '4、免责条款', id: '9' },
      { content: '“BIBF云书展”内容可能不正确或有编排上的错误。” BIBF云书展”不承认所有默示和/或明示的保证、并且不保证内容的正确性、可靠性、完整性或及时性。” BIBF云书展”对内容以及网站上登载的或与网站链接的任何事物，包括但不限于任何谬见、错误、遗漏、侵权、毁谤、谎言、或者其他可能是犯法或会引起权利主张或投诉的资料或遗漏不承担任何责任。', id: '10' },
      { content: '用户对使用”BIBF云书展”及内容的后果自负。有明示或默示的保证，包括任何对适销性，适于特定目的和不侵权的保证。”BIBF云书展”可能随时或定期会有变动，请不时查阅资料。” BIBF云书展”是在法律允许的最大范围内照现状提供资料和服务，但不提供任何种类的明示或保证。”BIBF云书展”不承认所网站不保证资料的正确性、可靠性、完整性或及时性。”BIBF云书展”对网站内容的错误或遗漏，或者任何用户通讯或个人化装置的删除、传输错误或未存储不承担任何责任。', id: '11' },
      { content: '“BIBF云书展”对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，非法使用网络服务或用户传送的信息有所变动。这些行为都有可能会导致” BIBF云书展”的形象受损，所以” BIBF云书展”事先提出这种损害的可能性。 在” BIBF云书展”的网页上发布信息或者利用” BIBF云书展”的服务时必须符合中国有关法规。网站有判定用户的行为是否符合本网站服务条款的要求和精神的保留权利，如果用户违背了服务条款或法律的规定，或与BIBF云书展的要求不符，网站有中断对其提供网络服务的权利。', id: '12' },
      { content: '本网站没有任何责任处理其他人在网站的公共区域提供的有可能失实、误导、淫秽、非法 或诽谤的该类资料。您承认本网站无法控制核查所有该类资料的真实性，并且网站也没有任何责任处理任何要求改正或删除该类资料的请求。', id: '13' },
      { content: '5、网络服务内容的所有权', id: '14' },
      { content: '“BIBF云书展”定义的网络服务内容包括：文字、软件、声音、图片、录象、图表中的全部内容；电子邮件的全部内容；” BIBF云书展”为用户提供的其他信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在” BIBF云书展”授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。” BIBF云书展”内所有的文章版权归原文作者和” BIBF云书展”共同所有，任何人需要转载，必须征得原文作者或” BIBF云书展”授权。” BIBF云书展”注册用户在” BIBF云书展”论坛发表的作品，” BIBF云书展”有权在网站内免费使用。', id: '15' },
      { content: '6、用户必须遵循', id: '16' },
      {
        contentArr: [
          '从中国境内向外传输技术性资料时必须符合中国有关法规。',
          '使用网络服务不作非法用途。',
          '不干扰或混乱网络服务。',
          '遵守所有使用网络服务的网络协议、规定、程序和惯例。',
          '用户须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽等信息资料。另外，用户也不能传输任何教唆他人构成犯罪行为的资料；不能传输助长国内不利条件和涉及国家安全的资料；不能传输任何不符合当地法规、国家法律和国际法律的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上提到的服务条款，” BIBF云书展”将作出独立判断立即取消用户服务帐号。用户需对自己在网上的行为承担法律责任。用户若在” BIBF云书展”上散布和传播反动、色情或其他违反国家法律的信息，” BIBF云书展”的系统记录有可能作为用户违反法律的证据。'
        ],
        id: '17'
      },
      { content: '7、法律', id: '18' },
      { content: '网络服务条款要与中华人民共和国的法律解释相一致，如发生” BIBF云书展”服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户产生法律效力和影响。', id: '19' },
      { content: '8、一般性原则', id: '20' },
      {
        contentArr: [
          '用户在使用BIBF云书展提供服务，必须遵循下列原则',
          '1、 遵守中国的法律法规，不得为任何非法目的使用书展平台；',
          '2、 不得利用书展平台进行任何可能对互联网正常运转造成不利影响的行为；',
          '3、 不得利用书展平台进行任何不利于中国图书进出口（集团）有限公司的行为；',
          '4、 不得利用书展平台内容以任何形式侵害任何人之专利、商标、商业秘密、著作权或其他专属权利；'
        ],
        id: '21'
      },
      { content: '<div style="font-weight: bold; text-indent: 2em;">如用户违法上述原则，给中国图书进出口（集团）有限公司以及BIBF云书展造成损害或损失的，由用户承担赔偿责任。</div>', id: '22' }
    ]
  },
  downLoad: {
    bannerUrl: {
      url: require('@/assets/bibf.png'),
      title: 'BIBF云书展'
    },
    title: 'BIBF云书展',
    name: '立即下载',
    list: [
      '智慧书展，一站式版权服务',
      '商机无限，云书展永不落幕'
    ],
    url: {
      url: require('@/assets/phone.png'),
      title: 'BIBF云书展'
    }
  }
}
